'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _jsxFileName = 'src/SureDesignSystem/Input/Input.js';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _InputModule = require('./Input.module.css');

var _InputModule2 = _interopRequireDefault(_InputModule);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var propTypes = {
  className: _propTypes2.default.string,
  wrapperClassName: _propTypes2.default.string,
  labelClassName: _propTypes2.default.string,
  errorClassName: _propTypes2.default.string,
  label: _propTypes2.default.node.isRequired,
  showLabelAsterisk: _propTypes2.default.bool,
  name: _propTypes2.default.string,
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  onBlur: _propTypes2.default.func,
  touched: _propTypes2.default.bool,
  error: _propTypes2.default.string
};
var defaultProps = {
  className: null,
  wrapperClassName: null,
  labelClassName: null,
  errorClassName: null,
  showLabelAsterisk: false,
  value: '',
  touched: false,
  error: null
};

function Input(_ref) {
  var className = _ref.className,
      wrapperClassName = _ref.wrapperClassName,
      labelClassName = _ref.labelClassName,
      errorClassName = _ref.errorClassName,
      label = _ref.label,
      showLabelAsterisk = _ref.showLabelAsterisk,
      touched = _ref.touched,
      error = _ref.error,
      props = _objectWithoutProperties(_ref, ['className', 'wrapperClassName', 'labelClassName', 'errorClassName', 'label', 'showLabelAsterisk', 'touched', 'error']);

  return _react2.default.createElement('div', {
    className: (0, _classnames2.default)(_InputModule2.default.wrapper, wrapperClassName),
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44
    },
    __self: this
  }, _react2.default.createElement('label', {
    className: (0, _classnames2.default)(_InputModule2.default.label, labelClassName),
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45
    },
    __self: this
  }, label, showLabelAsterisk && _react2.default.createElement('span', {
    className: _InputModule2.default.labelAsterisk,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47
    },
    __self: this
  }, '*'), _react2.default.createElement('input', _extends({}, props, {
    className: (0, _classnames2.default)(_InputModule2.default.input, _defineProperty({}, _InputModule2.default.input_error, touched && error), className),
    'data-testid': 'input_' + props.name,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48
    },
    __self: this
  }))), touched && error && _react2.default.createElement('p', {
    className: (0, _classnames2.default)(_InputModule2.default.error, errorClassName),
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59
    },
    __self: this
  }, error));
}

Input.propTypes = propTypes;
Input.defaultProps = defaultProps;
exports.default = Input;